import * as React from 'react';
import { useEntityPermissions } from '@gandi/acl';
import { DisabledContext } from '../formUtils/DisabledContext';
const TEMPLATE_WRITE = 'template:template:write';
const LoadPermission = ({
  sharingId
}) => {
  const {
    setDisabled
  } = React.useContext(DisabledContext);
  const {
    hasPermissions
  } = useEntityPermissions(sharingId);
  const canWriteTemplate = hasPermissions([TEMPLATE_WRITE]);
  React.useEffect(() => {
    setDisabled(!canWriteTemplate);
  }, [canWriteTemplate, setDisabled]);
  return null;
};
export default LoadPermission;